module.exports = __webpack_public_path__ + "static/media/item_2_9ll.8302fb68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_9ll.png
// module id = 126
// module chunks = 0